import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function InfoYellowIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="InfoYellowIcon" className={clsx("Filled", "Icon", className)} fill="none">
            <circle id="Elipse_1" cx="8" cy="8" r="8" fill="#ffc860" />
            <g id="Grupo_338" transform="translate(1.414 1.414)">
                <circle
                    id="Elipse_2"
                    cx="5"
                    cy="5"
                    r="5"
                    transform="translate(1.586 1.586)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <path
                    id="Trazado_5958"
                    d="M12,13.834V12"
                    transform="translate(-5.414 -5.414)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <path
                    id="Trazado_5959"
                    d="M12,8h0"
                    transform="translate(-5.414 -3.248)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </SvgIcon>
    );
}
